module.exports = __webpack_public_path__ + "img/Group 739.6b046b61.png";